import { render } from "./modal-gestione-notifica.vue?vue&type=template&id=8d20106e"
import script from "./modal-gestione-notifica.vue?vue&type=script&lang=js"
export * from "./modal-gestione-notifica.vue?vue&type=script&lang=js"

import "./modal-gestione-notifica.vue?vue&type=style&index=0&id=8d20106e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__